var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";
function SvgIconView(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    stroke: "#17BF88",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0 6.543C2.976 2.181 6.518 0 10.624 0c4.106 0 7.723 2.181 10.85 6.543-2.979 3.9-6.595 5.851-10.85 5.851S2.828 10.444 0 6.543z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 10.7,
    cy: 6.3,
    r: 5.5
  }))));
}
export default SvgIconView;